import { IconArrowRight, IconLoader2 } from '@tabler/icons-react';
import getTextColor from 'chat-ui/src/hooks/getTextColorContrast';
import { Button } from '@/ui/button';

interface ScreeningQuestionStateButtonProps {
  isButtonDisabled: boolean;
  submitScreeningAnswer: () => void;
  backgroundColor: string;
  buttonText: string;
  isLoading: boolean;
}

function ScreeningQuestionStateButton({
  isButtonDisabled,
  submitScreeningAnswer,
  backgroundColor,
  buttonText,
  isLoading,
}: ScreeningQuestionStateButtonProps) {
  return (
    <Button
      disabled={isButtonDisabled}
      onClick={submitScreeningAnswer}
      style={{
        backgroundColor,
        color: getTextColor(backgroundColor || '#FFFFFF'),
      }}
      className="border-white border-2 self-end px-4 font-semibold flex items-center gap-2 ml-auto mt-12"
    >
      {buttonText}
      {isLoading ? (
        <IconLoader2 className="animate-spin" size={20} />
      ) : (
        <IconArrowRight size={20} />
      )}
    </Button>
  );
}

export default ScreeningQuestionStateButton;
